import {Col, Form, Row, Select} from "antd";
import {monthOptions} from "../../../_helpers/variables";
// Компонент полей ввода периода
const {Option} = Select;

export const PeriodFields = ({form, yearOptions}) => (
    <Row gutter={16}>
        <Col span={8}>
            <Form.Item
                name="year"
                label="Год"
                rules={[{required: true, message: 'Выберите год'}]}
            >
                <Select placeholder="Выберите год">
                    {yearOptions.map(year => (
                        <Option key={year} value={year}>
                            {year}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </Col>
        <Col span={8}>
            <Form.Item
                name="month"
                label="Месяц"
                rules={[{required: true, message: 'Выберите месяц'}]}
            >
                <Select placeholder="Выберите месяц">
                    {monthOptions.map(month => (
                        <Option key={month.value} value={month.value}>
                            {month.label}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </Col>
    </Row>
);